export const NO_DATA_TEMPLATES = {
  default: 'default' as const,
};

/** Binary thousand for calculating file sizes */
export const BINARY_THOUSAND = 1024;

export const FILE_SIZE_UNITS = {
  GB: 'GB' as const,
  MB: 'MB' as const,
  TB: 'TB' as const,
  byte: 'byte' as const,
  kB: 'kB' as const,
};

export const FILE_SIZE_RUS_UNITS = {
  [FILE_SIZE_UNITS.byte]: 'байт' as const,
  [FILE_SIZE_UNITS.kB]: 'Кб' as const,
  [FILE_SIZE_UNITS.MB]: 'Мб' as const,
  [FILE_SIZE_UNITS.GB]: 'Гб' as const,
  [FILE_SIZE_UNITS.TB]: 'Тб' as const,
};

/** Ordered list with russian size units for calculating file sizes */
export const SIZE_RUS_UNITS = [
  FILE_SIZE_RUS_UNITS[FILE_SIZE_UNITS.byte],
  FILE_SIZE_RUS_UNITS[FILE_SIZE_UNITS.kB],
  FILE_SIZE_RUS_UNITS[FILE_SIZE_UNITS.MB],
  FILE_SIZE_RUS_UNITS[FILE_SIZE_UNITS.GB],
  FILE_SIZE_RUS_UNITS[FILE_SIZE_UNITS.TB],
];

/** Default number of decimal places for a rounded number */
export const DECIMALS_DEFAULT = 2;

/** Maximum allowed size of uploaded file */
export const MAX_FILE_SIZE = 100 * (BINARY_THOUSAND ** 2);

/** Minimum allowed size of uploaded file */
export const MIN_FILE_SIZE = 0;

export const COMPONENTS_NAMESPACES = {
  autoComplete: 'autoComplete',
  button: 'button',
  buttonGroup: 'buttonGroup',
  checkBox: 'checkBox',
  checkBoxTree: 'checkBoxTree',
  collapse: 'collapse',
  collapseBody: 'collapseBody',
  collapseHeading: 'collapseHeading',
  collapsePanel: 'collapsePanel',
  countDown: 'countDown',
  currency: 'currency',
  dateTimeInput: 'dateTimeInput',
  dateTimeInputRange: 'dateTimeInputRange',
  drawer: 'drawer',
  dropDown: 'dropDown',
  dropDownLink: 'dropDownLink',
  dropDownSelect: 'dropDownSelect',
  dropZone: 'dropZone',
  fileDrop: 'fileDrop',
  fileList: 'fileList',
  fileUpload: 'fileUpload',
  input: 'input',
  linkTree: 'linkTree',
  loader: 'loader',
  loaderComponent: 'loaderComponent',
  maskedInput: 'maskedInput',
  menu: 'menu',
  modal: 'modal',
  modalBody: 'modalBody',
  modalFooter: 'modalFooter',
  modalHeader: 'modalHeader',
  multiSelect: 'multiSelect',
  notifications: 'notifications',
  numericRange: 'numericRange',
  numericTextBox: 'numericTextBox',
  pagination: 'pagination',
  password: 'password',
  progressBar: 'progressBar',
  radio: 'radio',
  rating: 'rating',
  slider: 'slider',
  statusBar: 'statusBar',
  stickyPanel: 'stickyPanel',
  suggestionList: 'suggestionList',
  switcher: 'switcher',
  tabs: 'tabs',
  tags: 'tags',
  textarea: 'textarea',
  tooltip: 'tooltip',
  tour: 'tour',
  vstepper: 'vstepper',
  wizard: 'wizard',
} as const;

/** Error codes for DropZone, FileDrop и FileUpload */
export enum FileErrorCodes {
  None,
  FileIsTooSmall,
  FileIsTooBig,
  WrongFileFormat,
  AlreadyLoaded,
  TooManyFiles,
  NameIsTooLong,
}

/** Errors for future DropZone, FileDrop и FileUpload */
export const ERROR_MESSAGES = [
  { errorCode: FileErrorCodes.FileIsTooSmall, message: 'File size is too small' },
  { errorCode: FileErrorCodes.FileIsTooBig, message: 'File size is too big' },
  { errorCode: FileErrorCodes.WrongFileFormat, message: 'Unexpected file format' },
  { errorCode: FileErrorCodes.AlreadyLoaded, message: 'File already uploaded' },
  { errorCode: FileErrorCodes.TooManyFiles, message: 'Maximum files limit was reached' },
  { errorCode: FileErrorCodes.NameIsTooLong, message: 'File name is too long' },
];

export const predefinedAllowedSymbols = {
  numbers: /\d/,
};

export const predefinedForbiddenSymbols = {
  numbers: /\d/,
};
